interface QA {
  q: string;
  a: React.ReactNode;
}

const FAQ: QA[] = [
  {
    q: "L'audit est-il vraiment gratuit ?",
    a: (
      <>
        Oui, sans aucune contrepartie. Notre agent IA traite l'audit en 2-3 minutes —
        le coût marginal pour nous est de quelques centimes. Pas d'appel commercial,
        pas de mailing list automatique.
      </>
    ),
  },
  {
    q: "L'agent IA, c'est du marketing ou c'est vrai ?",
    a: (
      <>
        C'est vrai. L'agent tourne sur Cloudflare Workers, signé{" "}
        <code className="text-blue-300 font-mono text-sm bg-slate-800/60 px-1.5 py-0.5 rounded">
          audit@agents.levier-ia.fr
        </code>
        . Vous pouvez vérifier les en-têtes SPF/DKIM du mail reçu.
        L'orchestration compresse environ 4 h d'audit humain manuel en 2-3 minutes.
      </>
    ),
  },
  {
    q: "Mes données et celles de mon site sont-elles utilisées pour entraîner une IA ?",
    a: (
      <>
        <strong className="text-white">Non.</strong> Hébergement OVHcloud Roubaix.
        Zéro-data-retention sur tous les modèles IA appelés (clauses contractuelles
        avec OpenAI, Anthropic, Mistral). RGPD natif. Conservation 30 jours puis suppression.
      </>
    ),
  },
  {
    q: "Mon site a 6 mois. J'ai vraiment besoin d'une refonte ?",
    a: (
      <>
        Pas forcément. L'audit vous le dira honnêtement. Si votre site est sain
        techniquement, on peut faire un <em>upgrade GEO seul</em> à partir de{" "}
        <strong className="text-white">1 200 € HT</strong> : on garde votre design,
        on ajoute la couche schema + llms.txt + topical map.
      </>
    ),
  },
  {
    q: "Combien de temps avant de voir des résultats ?",
    a: (
      <>
        Sur le SEO classique : 3 à 6 mois (Google met à jour son index).
        Sur le GEO (ChatGPT, Perplexity), souvent{" "}
        <strong className="text-white">2 à 4 semaines</strong> : les LLM crawlers
        réindexent plus vite. C'est l'un des intérêts d'investir maintenant.
      </>
    ),
  },
  {
    q: "Et la formation Passeport IA ?",
    a: (
      <>
        C'est notre autre offre, distincte. Pour le moment, nos workshops sont en
        cours d'agrément Qualiopi. La refonte web ne nécessite aucun agrément et
        reste 100 % opérationnelle aujourd'hui.
      </>
    ),
  },
];

export function Faq() {
  return (
    <section id="faq" className="py-24 px-6 bg-slate-900 border-t border-slate-800">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-blue-400 uppercase tracking-wider mb-3">
            Questions fréquentes
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white">
            Les 6 questions qu'on nous pose tout le temps
          </h2>
        </div>

        <div className="space-y-3">
          {FAQ.map((item, i) => (
            <details
              key={i}
              className="group p-6 rounded-xl bg-slate-800/50 border border-slate-700/50 hover:border-blue-500/30 transition-colors open:border-blue-500/40 open:bg-slate-800/80"
            >
              <summary className="flex items-center justify-between cursor-pointer list-none">
                <h3 className="text-base sm:text-lg font-semibold text-white pr-4">
                  {item.q}
                </h3>
                <svg
                  className="w-5 h-5 text-blue-400 shrink-0 transition-transform duration-200 group-open:rotate-180"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </summary>
              <div className="mt-4 text-slate-300 leading-relaxed text-sm sm:text-base">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
